omadapp.components.ProgressBar = function($context) {
	var t = this
	var $ = jQuery

	t.setPercentage = setPercentage

	var $js_container =  $context.find(".js_container")
	var $js_cursor =  $context.find(".js_cursor")

	function setPercentage(percent) {
		$js_cursor.css({
			width: percent+"%"
		})
	}


}